import { useEffect } from "react";
import orderAPI from "../api/orderApi";
import { getSession, setSession, clearSession } from "../utils/sessionManager";
import { generateCartHash } from "../utils/cartHelper";
import { handleApiValidationError } from "../utils/apiErrorHandler";
import { showError } from "../utils/toastUtils";

// session mein jo jo cheez backend ko jaati hai, uska fingerprint
const getFormFingerprint = (formData) =>
  JSON.stringify({
    paymentMethod: formData.paymentMethod,
    email: formData.email,
    phone: formData.phone,
    firstName: formData.firstName,
    lastName: formData.lastName,
    address: formData.address,
  });

export const useCheckout = (cartItems, formData) => {
  const initSession = async () => {
    const existing = getSession();
    const hash = generateCartHash(cartItems);
    const formFingerprint = getFormFingerprint(formData);

    if (
      existing &&
      existing.cartHash === hash &&
      existing.formFingerprint === formFingerprint && // 👈 NEW
      new Date(existing.expiresAt) > new Date()
    ) {
      return existing;
    }

    // purana session invalid hai, hata do
    clearSession();

    try {
      const res = await orderAPI.createSession(formData);

      if (res.code === 200) {
        const result = res.data;

        const session = {
          sessionId: result.sessionId,
          expiresAt: result.expiresAt,
          cartHash: hash,
          formFingerprint, // 👈 NEW
        };

        setSession(session);
        return session;
      }

      throw new Error(res.message || "Failed to create checkout session");
    } catch (err) {
      handleApiValidationError(err, showError);
      return null;
    }
  };

  const placeOrder = async () => {
    const session = await initSession();

    // pehle yahan session undefined hone par crash hota tha
    if (!session) return null;

    const res = await orderAPI.placeOrder({
      sessionId: session.sessionId,
    });

    if (res.code === 200) {
      if (res.data.nextAction === "confirm") {
        clearSession();
        return {
          type: "COD_SUCCESS",
          payload: res.data,
          message: res.message,
        };
      }

      if (res.data.nextAction === "pay") {
        return {
          type: "PAYMENT_STARTED",
          payload: res.data,
          message: res.message,
        };
      }
    }

    return null;
  };

  // cart change → clear session
  useEffect(() => {
    clearSession();
  }, [cartItems]);

  return { placeOrder };
};